import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { api } from "@/lib/api";
import { SectionTitle } from "@/components/Kpi";
import { MappaZona } from "@/components/MappaZona";

/** Mappa di copertura della zona di competenza del commerciale (comuni e CAP della sua provincia). */
export default function MappaZonaPage() {
  const { slug } = useParams();
  const [comm, setComm] = useState(null);

  useEffect(() => {
    api.get("/commerciali").then((r) => setComm((r.data.commerciali || []).find((x) => x.slug === slug) || null))
      .catch(() => setComm(null));
  }, [slug]);

  return (
    <div data-testid={`mappa-zona-page-${slug}`} className="space-y-6">
      <SectionTitle sub={comm?.zona?.length ? `Comuni e CAP della provincia di ${comm.zona.join(", ")} · in rosso quelli con convenzionati` : ""}>
        Mappa zona · {(comm?.nome || slug).toUpperCase()}
      </SectionTitle>
      <MappaZona slug={slug} />
    </div>
  );
}
